import EditUserWorkScheduleModal from './edit-user-workschedule-modal-view'
export default EditUserWorkScheduleModal
